// Search Form ////////////////////////////////////////////////////////////////
//
// This file controls the submission tools for search.
//
// App -> Search Container -> Search Form
///////////////////////////////////////////////////////////////////////////////

// SETUP //////////////////////////////////////////////////////////////////////
// Third-party imports.
import { Row, Col, } from 'reactstrap'

// Local imports.
import ProgramSearch from './ProgramSearch/ProgramSearch'
import ProgramSearchDescription from './ProgramSearch/ProgramSearchDescription'
import ProgramSearchError from './ProgramSearch/ProgramSearchError'
import ProgramSearchLoading from './ProgramSearch/ProgramSearchLoading'
import PropTypes from 'prop-types'
import SearchResults from './SearchResults'

// Constants.
const noop = () => {}
const dispatchSig = ( action: any, ) => {}

// MAIN FUNCTION //////////////////////////////////////////////////////////////
function SearchForm ({
  activeMapProgramId = null,
  activeMapProgramType = null,
  activeProgramType = 'all',
  counties = [],
  doSearch = noop,
  eligibilityRequirements = [],
  emptyMessage = null,
  hideResults = false,
  industryTags = [],
  isLargeDisplay = false,
  isMobileDisplay = false,
  mapBounds = null,
  mapDispatch = dispatchSig,
  minimumEducationRequirements = [],
  mobileMapShowing,
  parentRef,
  programLevels = [],
  programTypes = [],
  searched = false,
  searchError = null,
  searchFilters = {},
  searching = false,
  searchResults = [],
  setActiveProgramId = noop,
  setActiveProgramType = noop,
  userLocation = null,
}: {activeMapProgramId: any,
  activeMapProgramType: any,
  activeProgramType: string,
  counties: any,
  doSearch: any,
  eligibilityRequirements: any,
  emptyMessage: any,
  hideResults: boolean,
  industryTags: any,
  isLargeDisplay: boolean,
  isMobileDisplay: boolean,
  mapBounds: any,
  mapDispatch: any,
  minimumEducationRequirements: any,
  mobileMapShowing: any,
  parentRef: any,
  programLevels: any,
  programTypes: any,
  searched: boolean,
  searchError: any,
  searchFilters: any,
  searching: boolean,
  searchResults: any,
  setActiveProgramId: any,
  setActiveProgramType: any,
  userLocation: any, }, ) {
  return (
    <>
      <ProgramSearch 
        counties={counties}
        eligibilityRequirements={eligibilityRequirements}
        industryTags={industryTags}
        isLargeDisplay={isLargeDisplay}
        isMobileDisplay={isMobileDisplay}
        mapDispatch={mapDispatch}
        minimumEducationRequirements={minimumEducationRequirements}
        mobileMapShowing={mobileMapShowing}
        onSearchClick={doSearch}
        parentRef={parentRef}
        programLevels={programLevels}
        programTypes={programTypes}
        searchFilters={searchFilters}
        setTypeFilter={setActiveProgramType}
        typeFilter={activeProgramType}
        userLocation={userLocation}
      />

      <Row className={`search-inner-row search-results ${!searching && 'd-none'}`}>
        <Col>
          <ProgramSearchLoading />
        </Col>
      </Row>
      <Row className={`mb-1 search-inner-row ${!searchError && 'd-none'}`}>
        <Col>
          <ProgramSearchError errorObj={searchError}/>
        </Col>
      </Row>
      { 
        searched && !searchError && (!hideResults) && <>
          <Row className={'search-inner-row search-results'}>
            <Col>
              <SearchResults 
                activeMapProgramId={activeMapProgramId}
                activeMapProgramType={activeMapProgramType}
                emptyMessage={emptyMessage}
                mapBounds={mapBounds}
                mapDispatch={mapDispatch}
                results={searchResults}
                setActiveProgramId={setActiveProgramId}
              />
            </Col>
          </Row>
        </>
      }
      { 
        !searched && <>
          <Row className={'search-description'}>
            <Col>
              <ProgramSearchDescription
                activeProgramType={activeProgramType}
              />
            </Col>
          </Row>
        </>
      }
    </>
  )
}

SearchForm.propTypes = {
  activeMapProgramId          : PropTypes.number,
  activeMapProgramType        : PropTypes.string,
  activeProgramType           : PropTypes.string,
  counties                    : PropTypes.array,
  doSearch                    : PropTypes.func,
  eligibilityRequirements     : PropTypes.array,
  emptyMessage                : PropTypes.string,
  hideResults                 : PropTypes.bool, 
  industryTags                : PropTypes.array,
  isLargeDisplay              : PropTypes.bool,
  isMobileDisplay             : PropTypes.bool,
  mapBounds                   : PropTypes.object,
  mapDispatch                 : PropTypes.func,
  minimumEducationRequirements: PropTypes.array,
  mobileMapShowing            : PropTypes.bool,
  parentRef                   : PropTypes.object,
  programLevels               : PropTypes.array,
  programTypes                : PropTypes.array,
  searched                    : PropTypes.bool,
  searchError                 : PropTypes.oneOfType([ PropTypes.object, PropTypes.string , ]),
  searchFilters               : PropTypes.object,
  searching                   : PropTypes.bool,
  searchResults               : PropTypes.array,
  setActiveProgramId          : PropTypes.func,
  setActiveProgramType        : PropTypes.func,
  userLocation                : PropTypes.object,
}

export default SearchForm